exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aggregate-options[data-v-004063ad] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.container-overview[data-v-004063ad] {\n  margin-top: -30px;\n}\n.container-overview .container-component[data-v-004063ad] {\n    padding-top: 30px;\n}\n", ""]);

// exports
